module.exports = __webpack_public_path__ + "media/C_sign_reveal.abdc484d.mp3";